export default {
  documentTypes: {
    list: [],
    loading: false
  },
  documentProcess: {
    list: [],
    loading: false
  },
  documentSubProcess: {
    list: [],
    loading: false
  },
  documentTypesExternals: {
    list: [],
    loading: false
  },
  documents: {
    list: [],
    loading: false
  },
  allDocuments: {
    list: [],
    loading: false
  },
  institutionTypes: {
    list: [],
    loading: false
  },
  institutions: {
    list: [],
    loading: false
  },
  subjectTypes: {
    list: [
      {
        id: '0',
        value: 'usuarios',
        label: 'Funcionarios'
      },
      {
        id: '1',
        value: 'unidades',
        label: 'Unidades'
      },
      {
        id: '2',
        value: 'oficinas',
        label: 'Oficina de Partes'
      },
      {
        id: '3',
        value: 'docDigital',
        label: 'DocDigital'
      },
      {
        id: '4',
        value: 'ministerios',
        label: 'Ministerio u Organismos'
      },
      {
        id: '5',
        value: 'empresas',
        label: 'Proveedores o Empresas'
      },
      {
        id: '6',
        value: 'personas',
        label: 'Personas/ciudadanos'
      },
      {
        id: '7',
        value: 'comisiones',
        label: 'Comisiones'
      },
      {
        id: '8',
        value: 'personasJuridicas',
        label: 'Personas Jurídicas'
      },
      {
        id: '9',
        value: 'organismoEstado',
        label: 'Organismo del estado'
      },
      {
        id: '10',
        value: 'sanitarias',
        label: 'Instituciones sanitarias'
      }
    ],
    loading: false
  },
  subjects: {
    type: '',
    list: [],
    loading: false
  },
  institutionsDocDigital: {
    list: [],
    loading: false
  },
  usersDocDigital: {
    list: [],
    loading: false
  },
  aprovals: {
    list: [],
    loading: false
  },
  groups: {
    list: [],
    loading: false
  },
  offices: {
    list: [],
    loading: false
  },
  groupUsers: {
    list: [],
    loading: false
  },
  activities: {
    list: [],
    loading: false
  },
  activityStates: {
    list: [],
    loading: false
  },
  userGroups: {
    list: [],
    loading: false
  },
  users: {
    value: {},
    loading: false
  },
  myDivisions: {
    list: [],
    loading: false
  },
  companyDivisions: {
    list: [],
    loading: false
  },
  sanitaryCompanies: {
    list: [],
    loading: false
  },
  isapres: {
    list: [],
    loading: false
  },
  afps: {
    list: [],
    loading: false
  },
  banks: {
    list: [],
    loading: false
  },
  academicDegree: {
    list: [],
    loading: false
  },
  nationality: {
    list: [],
    loading: false
  },
  title: {
    list: [],
    loading: false
  },
  subject: {
    list: [],
    loading: false
  },
  career: {
    list: [],
    loading: false
  },
  university: {
    list: [],
    loading: false
  },
  city: {
    list: [],
    loading: false
  },
  responsibilityCenter: {
    list: [],
    loading: false
  },
  paymentPeriod: {
    list: [],
    loading: false
  },
  contractPaymentPeriod: {
    list: [],
    loading: false
  },
  period: {
    list: [],
    loading: false
  },
  headOfCareer: {
    list: [],
    loading: false
  },
  administrativeSupport: {
    list: [],
    loading: false
  },
  administrativeResponsible: {
    list: [],
    loading: false
  },
  schAttachmentsSelectors: {
    list: [],
    loading: false
  },
  grcAttachmentsSelectors: {
    list: [],
    loading: false
  },
  scfAttachmentsSelectors: {
    list: [],
    loading: false
  },
  actAttachmentsSelectors: {
    list: [],
    loading: false
  },
  profiles: {
    value: {},
    loading: false
  },
};
